import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';
import LandingPage from '@cont/OfflineCentres/EnquiryPage';
import { getStaticData } from '@api/fetchers/offline-centres';
import FreeLayout from '@layout/FreeLayout/FreeLayout';

const OfflineEnquiry = ({ cmsData }) => {
  return (
    <>
      <NextSeo
        title="Unacademy Centres - Experience offline learning like never before"
        description="Learn face-to-face from the best Educators in your city. Get access to all the benefits of online subscription, 1on1 mentorship & state-of-the-art infrastructure. Subscribe today and get 10% off by using SAVE10"
      />
      <LandingPage cmsData={cmsData} />
    </>
  );
};

OfflineEnquiry.pageInfo = {
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    hideNudges: true,
    hideIntercom: true,
    showFixedHeader: true,
    disableDarkMode: true
  },
  isMWebSupported: true
};

export const getStaticProps = async () => {
  try {
    const cmsData = await getStaticData();
    return {
      props: {
        cmsData
      },
      revalidate: 60
    };
  } catch (error) {
    return {
      props: {},
      revalidate: 60
    };
  }
};

OfflineEnquiry.Layout = FreeLayout;
OfflineEnquiry.Layout.displayName = 'OfflineEnquiry';

OfflineEnquiry.Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default OfflineEnquiry;
OfflineEnquiry.Wrapper = null;
